import { QueryClient } from 'react-query'
import alertToast from '../components/shared/AlertToast'
import React from 'react'

const defaultResponse = {
  onError: (error) => {
    const message =
      error.response && error.response.data
        ? Object.keys(error.response.data.errors || []).map((e) => (
          <div key={e}>
            {e}: {error.response.data.errors[e][0]}
          </div>
        ))
        : error.message
    alertToast({
      message,
      type: 'danger',
      duration: 5000,
    })
  },
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...defaultResponse,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 0, // Data is considered stale immediately
      cacheTime: 0
    },
    mutations: {
      ...defaultResponse,
    },
  },
})

export const useGetFetchQuery = (name) => {
  return queryClient.getQueryData(name)
}
